import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import { Form, Input,Button, message } from 'antd';
export default function App() {
  const [form] = Form.useForm();

  // 配置 message 全局属性，固定在视口顶部
  message.config({
    top: 100,  // 距离视口顶部的像素值
    duration: 3,
    maxCount: 3,
  });

  const onFinish = async (values) => {
    try {
      const response = await fetch('/api/business/requestConsultation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          companyName: values.companyName,
          name: values.name,
          phone: values.phone,
          email: values.email,
          description: values.description
        })
      });

      const result = await response.json();
      if (result.success && result.code === "200") {
        message.success(result.data || '预约成功！我们会尽快与您联系');
        form.resetFields();
      } else {
        message.error(result.message || '预约失败，请稍后重试');
      }
    } catch (error) {
      message.error('网络错误，请稍后重试');
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'6'} />
        <AboutTitle name={'加入我们'} english={'JOIN US'}  />
        <div className='joinus'>
          <div className='joinus-con'>
            <div style={{textAlign:'center', paddingBottom:'15px', fontSize:'14px'}}>请完善信息，客服人员会尽快与您取得联系，为您提供产 品演示与咨询服务</div>
            <Form
              form={form}
              name="layout-multiple-horizontal"
              layout="horizontal"
              onFinish={onFinish}
            >
              <Form.Item
                label="公司名称"
                name="companyName"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[{ required: true, message: '请输入公司名称' }]}
              >
                <Input placeholder="请输入公司全称"  />
              </Form.Item>
              <Form.Item
                label="姓名"
                name="name"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[{ required: true, message: '请输入姓名' }]}
              >
                <Input placeholder="请输入姓名"  />
              </Form.Item>
              <Form.Item
                label="手机号码"
                name="phone"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[
                  { required: true, message: '请输入手机号码' },
                  { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }
                ]}
              >
                <Input placeholder="请输入联系手机号码"  />
              </Form.Item>
              <Form.Item
                label="E-mail"
                name="email"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[
                  { required: true, message: '请输入邮箱' },
                  { type: 'email', message: '请输入正确的邮箱格式' }
                ]}
              >
                <Input placeholder="请输入邮箱"  />
              </Form.Item>
              <Form.Item
                label="需求描述"
                name="description"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                rules={[{ required: true, message: '请输入需求描述' }]}
              >
                <Input.TextArea placeholder="请输入需求描述" rows={4} />
              </Form.Item>
              <Form.Item >
                <div className='buttomBo'>
                  <Button onClick={onReset}> 重置 </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                  >
                    立即预约
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
